export default function camelToUpperCase(string) {
    const result = string.replace(/([A-Z])/g);
    return result.charAt(0).toUpperCase() + string.substring(1);
}
